import { render, staticRenderFns } from "./AfaAnamnesiViewComponent.vue?vue&type=template&id=757c97d5"
import script from "./AfaAnamnesiViewComponent.vue?vue&type=script&lang=js"
export * from "./AfaAnamnesiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports